import ru from './ru';
import { applyKz } from './applyKz';

const kz = applyKz(ru);

export function getLocale(lang) {
  return lang === 'ҚАЗ' ? kz : ru;
}

export { ru, kz };
